import type { ReactNode } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useTopicPageData, useTopicPagePaginatedTrendingPetitionsData } from '#src/app/pages/topic/details/pageContext';

type Result = ModelHookResult<{
	petitionCountLabel: ReactNode;
	signatureCountLabel: ReactNode;
}>;

export function useTopicStats(): Result {
	const {
		data: { signatureCount, signatureCountLocalized },
	} = useTopicPageData();

	const {
		data: { totalCount, totalCountLocalized },
	} = useTopicPagePaginatedTrendingPetitionsData();

	const { translatePluralHtml } = useI18n();

	return {
		data: {
			petitionCountLabel: translatePluralHtml('corgi.topic_page.page_heading.petitions_for_topic', totalCount, {
				count: totalCountLocalized,
			}),
			signatureCountLabel: translatePluralHtml(
				'corgi.topic_page.page_heading.signatures_for_topic',
				signatureCount || 0,
				{
					count: signatureCountLocalized || '',
				},
			),
		},
	};
}
